import React, { useState } from "react";

const DisplayNameSection = ({
  displayName,
  setDisplayName,
  setNewDisplayName,
  newDisplayName,
}) => {
  const [editingDisplayName, setEditingDisplayName] = useState(false);

  const handleDisplayNameChange = (event) => {
    setNewDisplayName(event.target.value);
  };

  const handleDisplayNameCancel = () => {
    setEditingDisplayName(false);
    setNewDisplayName("");
  };

  const handleDisplayNameSave = () => {
    setDisplayName(newDisplayName);
    setEditingDisplayName(false);
    setNewDisplayName("");
  };

  return (
    <div className="mb-4">
      <h2 className="font-bold text-gray-700 text-lg mb-2">Display Name</h2>
      {editingDisplayName ? (
        <div>
          <input
            className="w-full border-gray-300 rounded-md shadow-sm mb-2"
            type="text"
            placeholder="Display name"
            value={newDisplayName}
            onChange={handleDisplayNameChange}
          />
          <div className="flex justify-end">
            <button
              className="bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-2 px-4 rounded-l"
              onClick={handleDisplayNameCancel}
            >
              Cancel
            </button>
            <button
              className="text-white bg-black hover:scale-[1.05] transition-all font-bold py-2 px-4 rounded-r"
              onClick={handleDisplayNameSave}
            >
              Save
            </button>
          </div>
        </div>
      ) : (
        <div>
          <p className="text-gray-500 text-sm">{displayName}</p>
          <button
            className="text-blue-500 hover:text-blue-700 text-sm"
            onClick={() => setEditingDisplayName(true)}
          >
            Edit
          </button>
        </div>
      )}
    </div>
  );
};

export default DisplayNameSection;
